// IMPORTANT: This file is auto-generated, please do not edit manually.
export * from '@remix-run/fetch-router/routes';
